export default {
  "donutChart": {
    "config": {
      "changed": true,
      "title": "Donut Chart",
      "navSection": "cart-custom",
      "icon": "donutChart",
      "image": "donutChart.png"
    },
    "items": {
      "legend": {
        "style": null,
        "circleDefaultIcon": null,
        "show": false,
        "position": "Top",
        "showTitle": false,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "labels": {
        "show": true,
        "labelStyle": "Category, percent of total",
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "percentageLabelPrecision": 2,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "position": "outside",
        "overflow": true
      },
      "slices": {
        "innerRadiusRatio": 65
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "rgba(255,255,255,0)",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "funnel": {
    "config": {
      "changed": false,
      "title": "Funnel",
      "navSection": "cart-custom",
      "icon": "funnel",
      "image": "funnel.png"
    },
    "items": {
      "categoryAxis": {
        "show": true,
        "color": "#252423",
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "dataPoint": {
        "fill": "#010000",
        "transparency": null,
        "showAllDataPoints": true
      },
      "labels": {
        "show": true,
        "color": "#252423",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelPosition": "OutsideEnd",
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "percentBarLabel": {
        "show": true,
        "color": "#252423",
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "pieChart": {
    "config": {
      "changed": false,
      "title": "Pie Chart",
      "navSection": "cart-custom",
      "icon": "pieChart",
      "image": "pieChart.png"
    },
    "items": {
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 12
      },
      "labels": {
        "show": true,
        "labelStyle": "Data",
        "color": "#252423",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "position": "inside"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "scatterChart": {
    "config": {
      "changed": false,
      "title": "Scatter Chart",
      "navSection": "cart-custom",
      "icon": "scatterChart",
      "image": "scatterChart.png"
    },
    "items": {
      "general": {
        "responsive": false,
        "dataVolume": 10000
      },
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "categoryAxis": {
        "show": true,
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": "#252423",
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      },
      "valueAxis": {
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": "#252423",
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#448822"
      },
      "shapes": {
        "markerSize": 3,
        "markerStyle": "triangle",
        "customizeSeries": true
      },
      "plotArea": {
        "transparency": 20
      },
      "categoryLabels": {
        "show": true,
        "color": "#EEEEEE",
        "fontSize": 11,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#ffffff",
        "backgroundTransparency": 30
      },
      "fillPoint": {
        "show": false
      },
      "colorByCategory": {
        "show": false
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "treemap": {
    "config": {
      "changed": false,
      "title": "Treemap",
      "navSection": "cart-custom",
      "icon": "treemap",
      "image": "treemap.png"
    },
    "items": {
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 12
      },
      "labels": {
        "show": true,
        "labelDisplayUnits": "0",
        "color": "#252423",
        "labelPrecision": 0,
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "categoryLabels": {
        "show": true,
        "color": "#252423",
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "waterfallChart": {
    "config": {
      "changed": false,
      "title": "Waterfall Chart",
      "navSection": "cart-custom",
      "icon": "waterfallChart",
      "image": "waterfallChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "categoryAxis": {
        "show": true,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      },
      "valueAxis": {
        "show": true,
        "position": "Right",
        "start": 0,
        "end": 10,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": "301B8AA",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": "#252423",
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      },
      "labels": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#ffffff",
        "backgroundTransparency": 30
      },
      "plotArea": {
        "transparency": 20
      },
      "dataPoint": {
        "defaultColor": "#448822"
      },
      "sentimentColors": {
        "increaseFill": "#0928DD",
        "decreaseFill": "#AA28DD",
        "totalFill": "#FF28DD",
        "otherFill": "#09EEDD"
      },
      "breakdown": {
        "maxBreakdowns": 3
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  }
}